import { Directive, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ApplicationRoutingService } from '@shared/services/application-routing.service';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { ApplicationType } from '@shared/enums/application-type.enum';
import { getEnumKeyByValue } from '@shared/utils/enum';
import { ApplicationTypeModalSource } from './enums/application-type-modal-source.enum';
import { RegisterApplicationModalComponent } from '@domains/admin/components/register-application/register-application-modal.component';

@Directive({
  selector: '[appApplicationTypeSubmit]',
  standalone: true,
  host: {
    '(click)': 'submitForm()',
  },
})
export class ApplicationTypeSubmitDirective {
  public portalSource = input.required<ApplicationTypeModalSource>();
  public form = input.required<FormGroup>();
  public dialogRef = input.required<DialogRef>();

  private readonly _applicationRouting = inject(ApplicationRoutingService);
  private readonly _dialog = inject(Dialog);

  protected submitForm(): void {
    const formGroup = this.form();
    const selectedApplicationType = formGroup.value.applicationType;
    const selectedTenant = this.getTenantTypeByApplicationType(
      selectedApplicationType,
    );

    if (formGroup.invalid) {
      formGroup.markAllAsTouched();
      return;
    }

    this.dialogRef().close();

    if (this.portalSource() === ApplicationTypeModalSource.PUBLIC) {
      this._applicationRouting.startNewApplication(selectedTenant);
    } else {
      this.openClerkPortalRegisterModal(selectedTenant);
    }
  }

  private getTenantTypeByApplicationType(
    applicationType: keyof typeof ApplicationType,
  ): TenantKey {
    if (
      applicationType ===
      getEnumKeyByValue(ApplicationType, ApplicationType.ESTATE)
    ) {
      return TenantKey.PROBATE;
    } else if (
      applicationType ===
      getEnumKeyByValue(
        ApplicationType,
        ApplicationType.GUARDIANSHIP_CONSERVATORSHIP,
      )
    ) {
      return TenantKey.GUARDIANSHIP;
    }
    if (
      applicationType ===
      getEnumKeyByValue(ApplicationType, ApplicationType.MINOR_ESTATES)
    ) {
      return TenantKey.MINOR;
    }
    if (
      applicationType ===
      getEnumKeyByValue(ApplicationType, ApplicationType.TRUST)
    ) {
      return TenantKey.TRUST;
    }
    return TenantKey.PROBATE;
  }

  private openClerkPortalRegisterModal(tenantType: TenantKey) {
    this._dialog.open(RegisterApplicationModalComponent, {
      data: { tenantType },
    });
  }
}
